import { Box, Container, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { layoutContainer, layoutContent } from "../../styles/commonStyles";
import MessageAlert from "../Common/MessageAlert";
import Footer from "./Footer";
import Header from "./Header";

const Layout = ({ children }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [message, setMessage] = React.useState("");
  const theme = useTheme();

  useEffect(() => {
    if (location.state?.error === "auth_required") {
      setMessage(t("errors.loginRequired"));
      window.history.replaceState({}, document.title);
    }
  }, [location, t]);

  return (
    <Box sx={layoutContainer(theme)}>
      <Header />
      {message && (
        <MessageAlert severity="warning" onClose={() => setMessage("")}>
          {message}
        </MessageAlert>
      )}
      <Container maxWidth="lg" disableGutters sx={layoutContent(theme)}>
        {children}
      </Container>
      <Footer />
    </Box>
  );
};

export default Layout;
